







import Vue from "vue";

// Vue Components
import DeviceTreeAppPage from "@/components/DeviceTreeAppPage.vue";
// import MainSection from "@/views/App/ServiceAndUpdates/DownloadLogs/MainSection.vue";
import MainSection from "@/views/App/ServiceAndUpdates/DownloadLogs/MainSection.vue";

// Model
import * as routes from "@/router/routes";

export default Vue.extend({
    components: {
        DeviceTreeAppPage,
        // MainSection,
        MainSection,
    },
    data() {
        return {
            routes,
            deviceTreeSelectedObjectItems: [],
        };
    },
    computed: {
        menuRoutes() {
            return this.$store.getters.availableMenu;
        },

        styleProps() {
            var found = false;
            var resultObj = { icon: null, title: null, color: null };

            var findIconColorAndTitle: Function = (node: any) => {
                if (!found) {
                    if (node.children && node.children.length > 0) {
                        node.children.forEach((child) => {
                            findIconColorAndTitle(child);
                        });
                    } else {
                        if (node.path == this.routes.DownloadLogs) {
                            resultObj.icon = node.icon;
                            resultObj.title = this.$t(node.name_i18n);
                            resultObj.color = node.color;
                            found = true;
                        }
                    }
                }
            };

            this.menuRoutes.forEach((route) => {
                findIconColorAndTitle(route);
            });

            return resultObj;
        },

        icon() {
            return this.styleProps.icon ? this.styleProps.icon : "";
        },

        title() {
            return this.styleProps.title ? this.styleProps.title : "";
        },

        color() {
            return this.styleProps.color ? this.styleProps.color : "";
        },
    },
});
